import { CheckCircle2 } from "lucide-react";
import SEO from "@/components/SEO";

/**
 * Landing page Supabase redirects to after a successful email verification.
 * Intentionally has NO link back to the website or app — users simply close
 * this tab/window and open the FitAura app to sign in.
 */
export default function AuthConfirmed() {
  return (
    <>
      <SEO title="Email verified — FitAura" description="Your email has been verified." />
      <main className="flex min-h-[100dvh] items-center justify-center bg-[#0e0e11] px-6 py-10 text-[#e7e4ec]">
        <div className="w-full max-w-md rounded-3xl border border-white/10 bg-[#15151a] p-8 text-center shadow-[0_20px_60px_-10px_rgba(172,138,255,0.35)]">
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#ac8aff] to-[#8f60fa]">
            <CheckCircle2 className="h-9 w-9 text-white" strokeWidth={2.5} />
          </div>
          <h1
            className="mb-3 text-2xl font-bold uppercase tracking-[0.18em] text-white"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Email verified
          </h1>
          <p className="text-sm leading-relaxed text-[#acaab1]">
            You're all set. You can close this window and open the FitAura app to sign in.
          </p>
        </div>
      </main>
    </>
  );
}
